module.exports = __webpack_public_path__ + "img/deodorizer.c50c7696.jpg";